import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginCredentials } from '../types/login-credentials';
import { tap } from 'rxjs/operators';
import { UserService } from '../../core/services';
import { Token } from '../types/token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public readonly ACCESS_TOKEN_KEY = 'ml_access_token';
  public readonly REFRESH_TOKEN_KEY = 'ml_refresh_token';

  constructor(private userService: UserService, private http: HttpClient) {}

  get hasTokens() {
    return (
      !!localStorage.getItem(this.ACCESS_TOKEN_KEY) &&
      !!localStorage.getItem(this.REFRESH_TOKEN_KEY)
    );
  }

  login(loginCredentials: LoginCredentials) {
    return this.http.post('login', loginCredentials).pipe(
      tap((token: Token) => {
        this.saveCredentials(token);
      })
    );
  }

  logout() {
    this.clearCredentials();
    this.userService.removeCurrentUser();
  }

  refreshToken() {
    const refreshToken = localStorage.getItem(this.REFRESH_TOKEN_KEY);
    return this.http
      .post('refresh-token', {
        refresh: refreshToken
      })
      .pipe(
        tap((token: Token) => {
          localStorage.setItem(this.ACCESS_TOKEN_KEY, token.access);
        })
      );
  }

  private saveCredentials(token: Token) {
    localStorage.setItem(this.ACCESS_TOKEN_KEY, token.access);
    localStorage.setItem(this.REFRESH_TOKEN_KEY, token.refresh);
  }

  private clearCredentials() {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
  }
}
